<template>
	<div class="passport-field">
		<div class="w5-form-row">
			<div v-for="(field, idx) in fields"
				v-if="fieldVisibility(idx)"
				class="w5-field"
				:class="idx + (idx === 'num' && country !== 'RU' ? ' union' : '')"
				:key="idx">
				<div class="w5-field-placeholder"
					:class="{ 'active': field.focused || field.value, 'readonly': readonly === true }">
					{{ field.title | ftc }}<span v-if="required" class="required-field"> *</span>
				</div>
				<template v-if="idx === 'date'">
					<manualDateComponent
						v-model="fields.date.value"
						:class="{ 'haserror': errorMessage ||  field.error }"
						:disabled="readonly === true ? 'disabled' : false"
						@error="onDateError"
						@focus="onFocus('date')"
						@blur="onBlur('date')"
						@keydown.enter="enterKeyDown"
						@input="onInput('date', $event)" />
					<div v-show="field.error"
						class="alert alert-danger w5-alert-valid"
						role="alert"
						v-withSafeTags="localeFtc(field.error)" />
				</template>
				<input v-else-if="fieldVisibility(idx)"
					type="text"
					:ref="idx"
					:class="{ 'haserror': errorMessage || fields.date.error }"
					:disabled="readonly === true ? 'disabled' : false"
					v-model="field.value"
					@focus="onFocus(idx)"
					@blur="onBlur(idx)"
					@keydown.enter="enterKeyDown"
					@input="onInput(idx, $event)" />
				<transition name="fade" mode="out-in">
					<div class="w5-tooltip-wrapper" v-show="field.focused && !field.error">
						<span class="w5-tooltip">{{ field.hint | ftc }}</span>
					</div>
				</transition>
			</div>
		</div>
		<div v-show="errorMessage && !fields.date.error"
			class="alert alert-danger w5-alert-valid"
			role="alert"
			v-withSafeTags="localeFtc(errorMessage)" />
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import manualDateComponent from '@/components/elements/date'
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	name: 'passportComponent',

	//=========================================================================
	props: [
		'title',
		'required',
		'readonly',
		'value',
		'name',
		'errorMessage'
	],

	//=========================================================================
	data() {
		return {
			fields: {
				ser: {
					focused: false,
					title: 'passport/series',
					hint: 'person/pattern: 1234',
					value: ''
				},
				num: {
					focused: false,
					title: 'passport/number',
					hint: 'person/pattern: 123456',
					value: ''
				},
				issuer: {
					focused: false,
					title: 'passport/who',
					hint: 'person/pattern: 48 отделом милиции г. Москвы',
					value: ''
				},
				date: {
					focused: false,
					title: 'passport/when',
					hint: 'person/pattern: 31.12.2000',
					value: null
				}
			},
			Value: null,
			country: null
		}
	},

	//=========================================================================
	created() {
		EventBus.$on('w5-get-field-value-answer', this.countryValue)
		this.Init()
	},

	//=========================================================================
	mounted() {
		EventBus.$emit('w5-get-field-value', this.name.replace('passport', 'country'))
	},

	//=========================================================================
	beforeDestroy() {
		EventBus.$off('w5-get-field-value-answer', this.countryValue)
	},

	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		Init() {
			if (this.value !== undefined && this.value !== null)
			{
				let _match = String(this.value).match(/^([0-9 a-zA-Z\-а-яёА-ЯЁ]+) выдан (.{4,}), (\d{2}\.\d{2}\.\d{4})$/i)
				if (_match && _match.length === 4)
				{
					this.fields.issuer.value = _match[2]
					this.fields.date.value = _match[3]

					if (this.country === 'RU')
					{
						this.fields.num.title = 'Номер'
						this.fields.num.hint = 'person/pattern: 123456'

						if (_match[1].indexOf(' ') > -1)
						{
							let _parts = _match[1].split(' ')
							this.fields.num.value = _parts.pop()
							this.fields.ser.value = _parts.join(' ')
						}
						else
						{
							this.fields.num.value = _match[1]
						}
					}
					else
					{
						this.fields.num.title = 'Серия и/или номер'
						this.fields.num.hint = 'person/pattern: 1234 123456'
						this.fields.num.value = _match[1]
					}
				}
				this.makeValue()
			}
		},

		//---------------------------------------------------------------------
		onFocus(fieldName) {
			this.fields[fieldName].focused = true
			this.fields[fieldName].error = ''

			this.$emit('focus')
		},

		//---------------------------------------------------------------------
		onBlur(fieldName) {
			this.fields[fieldName].focused = false
			this.makeValue()

			if (this.Value)
			{
				if (fieldName === 'date' && this.fields.date.value === 'not-date')
				{
					this.fields.date.error = 'person/error_date'
					return
				}

				if (this.country === 'RU')
				{
					if (!this.fields.ser.value || !this.fields.num.value)
						return this.$emit('error', 'person/error_passport_reg')
				}
				else
				{
					if (!this.fields.num.value)
						return this.$emit('error', 'person/error_passport_reg')
				}
			}

			this.$emit('blur')
		},

		//---------------------------------------------------------------------
		enterKeyDown(e) {
			this.$emit('enterKeyDown', e)
		},

		//---------------------------------------------------------------------
		onDateError(text) {
			if (text && this.fields.date.error !== text)
				this.fields.date.error = text
		},

		//---------------------------------------------------------------------
		onInput(what, event) {
			if (!what) return

			if (event && event.target && (what === 'ser' || what === 'num' || what === 'issuer'))
				this.$set(this.fields[what], 'value', event.target.value)

			this.makeValue()
			this.$emit('input', this.Value)
		},

		//---------------------------------------------------------------------
		fieldVisibility(name) {
			if (name !== 'ser') return true
			return this.country === 'RU'
		},

		//---------------------------------------------------------------------
		countryValue(data) {
			if (!data || !data.name) return
			if (data.name !== this.name.replace('passport', 'country')) return

			this.country = data.value ? data.value : null
			this.Init()
		},

		//---------------------------------------------------------------------
		makeValue() {
			if (this.country === 'RU')
			{
				this.Value = this.fields.ser.value
				if (this.fields.num.value) this.Value += ' ' + this.fields.num.value
			}
			else
			{
				this.Value = this.fields.num.value
			}

			if (this.fields.issuer.value) this.Value += ' выдан ' + this.fields.issuer.value
			if (this.fields.date.value)
			{
				if (/^\d{2}.\d{2}.\d{4}/.test(this.fields.date.value))
					this.Value += ', ' + this.fields.date.value
				else if (/^\d{4}-\d{2}-\d{2}/.test(this.fields.date.value))
				{
					let _val = this.fields.date.value
					_val = _val.substr(8, 2) + '.' + _val.substr(5, 2) + '.' + _val.substr(0, 4)
					this.Value += ', ' + _val
				}
			}
		}

		//---------------------------------------------------------------------
	},

	//=========================================================================
	components: {
		manualDateComponent
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.passport-field > .w5-alert-valid {
	top: 56px;
	margin-right: 10px;
}

.passport-field > .w5-form-row > .w5-field.ser,
.passport-field > .w5-form-row > .w5-field.num,
.passport-field > .w5-form-row > .w5-field.index {
	flex: none;
	width: 120px;
}
.passport-field > .w5-form-row > .w5-field.num.union {
	width: auto;
}

.passport-field > .w5-form-row > .w5-field.date {
	flex: none;
	width: 150px;
}
.passport-field > .w5-form-row > .w5-field.receiver {
	flex: none;
	width: 200px;
}

.passport-field > .w5-form-row > .w5-field > .w5-field-placeholder {
    position: absolute;
    left: 20px;
    height: 45px;
    width: calc(100% - 30px);
    padding: 3px 0;
    line-height: 39px;
    font-weight: 400;
    color: #ccc;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    pointer-events: none;
    z-index: 0;
}

.passport-field > .w5-form-row > .w5-field > .w5-field-placeholder.active {
    font-size: 75%;
    line-height: 1;
    color: #9f9f9f;
}
.passport-field > .w5-form-row > .w5-field > .w5-field-placeholder.readonly {
	z-index: 1
}

.passport-field > .w5-form-row > .w5-field > .w5-field-placeholder > .required-field,
.passport-field > .w5-form-row > .w5-field > .w5-field-placeholder > span > .required-field {
    color: #ccc;
}
.passport-field > .w5-form-row > .w5-field > .w5-field-placeholder.active > .required-field,
.passport-field > .w5-form-row > .w5-field > .w5-field-placeholder.active > span > .required-field {
    color: red;
}

.passport-field > .w5-form-row > .w5-field > .w5-field-placeholder > .short-title {
	display: inline;
}
.passport-field > .w5-form-row > .w5-field > .w5-field-placeholder > .long-title {
	display: none;
}

@media screen and (max-width: 767px) {
	.passport-field > .w5-form-row > .w5-field > .w5-field-placeholder > .short-title {
		display: none;
	}
	.passport-field > .w5-form-row > .w5-field > .w5-field-placeholder > .long-title {
		display: inline;
	}
}
</style>



// WEBPACK FOOTER //
// passport.vue?5b36a040